import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)(({ theme }) => ({
    height: "100%",
    display: "grid",
    gridTemplateRows: "56px 1fr",
    minHeight: 0,
    backgroundColor: theme.palette.type === "dark" ? "#131614" : "#ffffff",
    // Safe-area inset is owned by MessageInputCustom/mainWrapper — do not
    // duplicate here, otherwise mobile viewports stack two insets and a
    // ~140px blank band appears below the input on 360x640 emulation.
    // Compress the Chat/Tickets header row on xs from 56→44px to match the
    // shrunk BottomNavigation height in TicketsAdvanced/index.js. The grid
    // track is what actually allocates the space; leaving it at 56px would
    // just put empty padding around the smaller pill.
    [theme.breakpoints.down("xs")]: {
        gridTemplateRows: "44px 1fr",
    },
}))

export default TicketAdvancedLayout;